import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Users, RefreshCw } from "lucide-react";

export default function PersonasTab({ projectId, onRefresh }) {
  const [personas, setPersonas] = useState([]);
  const [busy, setBusy] = useState(false);

  async function load() {
    try { const { data } = await api.get("/personas", { params: { project_id: projectId } }); setPersonas(data); }
    catch { toast.error("Failed to load personas"); }
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [projectId]);

  async function reseed() {
    setBusy(true);
    try {
      const { data } = await api.post(`/projects/${projectId}/reseed-personas`, null, { params: { target_count: 40 } });
      toast.success(`Created ${data.created} additional personas`);
      load(); onRefresh?.();
    } catch { toast.error("Reseed failed"); }
    finally { setBusy(false); }
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2 text-sm">
          <Users className="w-4 h-4 text-primary" />
          <span className="txt-mono">{personas.length} personas</span>
        </div>
        <button onClick={reseed} disabled={busy} className="inline-flex items-center gap-2 text-xs px-3 py-2 border border-border hover:border-primary disabled:opacity-50 rounded-sm">
          <RefreshCw className={`w-3 h-3 ${busy ? "animate-spin" : ""}`} /> Reseed up to 40
        </button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
        {personas.map((p) => (
          <div key={p.id} className="border border-border p-3 bg-card hover:border-primary/50 transition-colors">
            <div className="flex items-center gap-3 mb-2">
              <img src={p.avatar_url} alt={p.username} className="w-10 h-10 rounded-sm border border-border bg-secondary" />
              <div className="min-w-0">
                <div className="text-sm font-medium truncate">{p.username}</div>
                <div className="text-[10px] txt-mono uppercase text-muted-foreground truncate">{p.expertise}</div>
              </div>
            </div>
            <div className="text-xs text-muted-foreground line-clamp-2">{p.bio || p.tone}</div>
            <div className="flex flex-wrap gap-1 mt-2">
              {(p.badges || []).slice(0, 3).map((b) => (
                <span key={b} className="text-[9px] txt-mono uppercase border border-primary/60 text-primary px-1 py-0.5 rounded-sm">{b}</span>
              ))}
              {p.location && (
                <span className="text-[9px] txt-mono uppercase border border-border text-muted-foreground px-1 py-0.5 rounded-sm">{p.location}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
